/**
 * Created by xinjundong on 2017/11/21.
 */
import Vuex from 'vuex'
import Vue from 'vue'
import * as api from '../api/api'
import {formatTime} from '../api/utils/funcs'
function replaceTpl (str, data) {
  str = str.replace(/<!--IMG#([0-9]+)-->/g, function (all, num) {
    num = Number(num)
    let source = data[num].src
    let str = ''
    if (num === 0) {
      str = '<div class="img-box"><img src="' + source + '"></div>'
    } else {
      str = '<div class="img-box"><img src="//m1.auto.itc.cn/appImage/sohu-default.png" data-src="' + source + '"></div>'
    }
    return str
  })
  str = str.replace(/width=500&amp;height=375&amp;/g, '').replace(/<iframe/g, '<iframe style=\"width: 100%;height: 250px;border-width:0\"')
  return str
}
function replaceVideoTpl (str, data) {
  str = str.replace(/<!--VIDEO#([0-9]+)-->/g, function (all, num) {
    num = Number(num)
    let vid = data[num].video_id
    let vstr = '<div class="video-box" data-bid="' + vid + '"></div>'
    return vstr
  })
  return str
}

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    hot: [],
    recommend: [],
    content: {}
  },
  getters: {
    contents: (state) => {
      if (!state.content.content) {
        return {}
      }

      state.content.content = replaceTpl(state.content.content, state.content.img)
      if (state.content.video) {
        state.content.content = replaceVideoTpl(state.content.content, state.content.video)
      }
      state.content.published_at = formatTime(state.content.published_at)
      return state.content
    },
    hots: (state) => {
      if (state.hot.length === 0) {
        return []
      }
      state.hot.forEach(function (element, index) {
        if (!element) {
          return
        }
        element.published_at = formatTime(element.published_at)
      })
      return state.hot && state.hot.slice(0, 4)
    },
    recommends: (state) => {
      if (state.recommend.length === 0) {
        return []
      }
      state.recommend.forEach(function (element, index) {
        if (!element) {
          return
        }
        if (isNaN(element.published_at)) {
          return
        }
        element.published_at = formatTime(element.published_at)
      })
      return state.recommend
    },
    lastId: (state) => {
      if (state.recommend.length === 0) {
        return null
      }
      let last = state.recommend[state.recommend.length - 1]
      if (last) {
        return last.hot_at
      } else {
        return null
      }
    }
  },
  mutations: {
    setHot (state, payload) {
      state.hot = payload
    },
    setRecommend (state, payload) {
      state.recommend = state.recommend.concat(payload)
    },
    setContent (state, payload) {
      state.content = payload
    }
  },
  actions: {
    requestHot ({commit}) {
      api.getHots().then(function (json) {
        commit('setHot', json.data)
      })
    },
    requestRecommend ({commit}, maxId) {
      api.getRecs(maxId).then(function (json) {
        window.loadingFlag = false
        commit('setRecommend', json.data)
      })
    },
    requestContent ({commit}, newsId) {
      api.getContent(newsId).then(function (json) {
        commit('setContent', json.data)
      })
    },
    requestShare ({commit}, data) {
      api.shareVisit(data)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js